import React, { PureComponent } from 'react';
import { withRouter, NavLink } from 'react-router-dom';

class DashboardNavigation extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showAccountMenu: false
    }
  }

  render() {
    return (<div className="row dashboard-navigation for-admin" ref={this.setWrapperRef}>
      <NavLink className="col" to="/admin/bookings" activeClassName="active"><h3>Bookings</h3></NavLink>
      <NavLink className="col" to="/admin/manage-listings" activeClassName="active"><h3>Manage Listings</h3></NavLink>
      <NavLink to="/admin/users" className="col" activeClassName="active"><h3>Manage Users</h3></NavLink>
      <NavLink to="/admin/streamline-account" className="col" activeClassName="active"><h3>Streamline Account</h3></NavLink>
    </div>);
  }
}

export default withRouter(DashboardNavigation);
